'use client';

import { useAuth } from '@clerk/nextjs';

// Clerk's `<Show>` resolves auth on the server, which forces the route to render
// per-request. The homepage prerenders instead, so the branch is decided in the
// browser: the static HTML carries the signed-out tree (also what anonymous
// visitors should see) and signed-in users swap to their tree once Clerk has
// loaded.
export function AuthGate({
  signedIn,
  signedOut,
}: {
  readonly signedIn: React.ReactNode;
  readonly signedOut: React.ReactNode;
}): React.ReactNode {
  const { isLoaded, isSignedIn } = useAuth();

  return isLoaded && isSignedIn ? signedIn : signedOut;
}
